"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.greaterThanOrEqual = exports.greaterThan = exports.lessThanOrEqual = exports.lessThan = exports.numberEqual = exports.modulo = exports.remainder = exports.quotient = exports.divide = exports.multiply = exports.subtract = exports.add = void 0;
const sExpression_1 = require("../sExpression");
const mustMapToNumbers = (opName, args) => {
    const mapped = [];
    for (const arg of args) {
        if (arg.type !== 'number') {
            throw new Error(opName + ' expects numbers as arguments, but encountered ' + arg.type);
        }
        mapped.push(arg.value);
    }
    return mapped;
};
const reduceNumericalArgs = (op, init, args) => {
    return sExpression_1.makeNumber(args.reduce(op, init));
};
exports.add = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '+',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 0
    },
    body: (args) => reduceNumericalArgs((acc, next) => acc + next, 0, mustMapToNumbers('+', args))
};
exports.subtract = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '-',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 1
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('-', args);
        if (mappedArgs.length === 1) {
            return sExpression_1.makeNumber(-mappedArgs[0]);
        }
        return reduceNumericalArgs((acc, next) => acc - next, mappedArgs[0], mappedArgs.slice(1));
    }
};
exports.multiply = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '*',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 0
    },
    body: (args) => reduceNumericalArgs((acc, next) => acc * next, 1, mustMapToNumbers('*', args))
};
exports.divide = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '/',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 1
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('/', args);
        if (mappedArgs.length === 1) {
            if (mappedArgs[0] === 0) {
                throw new Error('division by zero');
            }
            return sExpression_1.makeNumber(1 / mappedArgs[0]);
        }
        return reduceNumericalArgs((acc, next) => {
            if (next === 0) {
                throw new Error('division by zero');
            }
            return acc / next;
        }, mappedArgs[0], mappedArgs.slice(1));
    }
};
exports.quotient = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'quotient',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('quotient', args);
        if (mappedArgs[1] === 0) {
            throw new Error('division by zero');
        }
        return sExpression_1.makeNumber(Math.floor(mappedArgs[0] / mappedArgs[1]));
    }
};
exports.remainder = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'remainder',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('remainder', args);
        if (mappedArgs[1] === 0) {
            throw new Error('division by zero');
        }
        return sExpression_1.makeNumber(mappedArgs[0] % mappedArgs[1]);
    }
};
exports.modulo = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'modulo',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('modulo', args);
        if (mappedArgs[1] === 0) {
            throw new Error('division by zero');
        }
        return sExpression_1.makeNumber(((mappedArgs[0] % mappedArgs[1]) + mappedArgs[1]) % mappedArgs[1]);
    }
};
exports.numberEqual = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '=',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('=', args);
        return {
            type: 'boolean',
            value: mappedArgs[0] === mappedArgs[1]
        };
    }
};
exports.lessThan = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '<',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('<', args);
        return {
            type: 'boolean',
            value: mappedArgs[0] < mappedArgs[1]
        };
    }
};
exports.lessThanOrEqual = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '<=',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('<=', args);
        return {
            type: 'boolean',
            value: mappedArgs[0] <= mappedArgs[1]
        };
    }
};
exports.greaterThan = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '>',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('>', args);
        return {
            type: 'boolean',
            value: mappedArgs[0] > mappedArgs[1]
        };
    }
};
exports.greaterThanOrEqual = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: '>=',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => {
        const mappedArgs = mustMapToNumbers('>=', args);
        return {
            type: 'boolean',
            value: mappedArgs[0] >= mappedArgs[1]
        };
    }
};
//# sourceMappingURL=arithmetic.js.map